import { parseTextParams } from '../util/TextUtil';
export class GaDataStore {
    constructor(rootStore) {
        Object.defineProperty(this, "cmsDataStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.cmsDataStore = rootStore.cmsDataStore;
    }
    getPageTitle() {
        return document.title;
    }
    push(data, params) {
        if (window.dataLayer) {
            const resolved = this.resolveGaData(data, params);
            window.dataLayer.push(resolved);
        }
    }
    resolveGaData(data, params) {
        const { eventLabel } = data;
        const label = eventLabel && params ? this.createEventLabel(eventLabel, params) : eventLabel;
        return { ...data, eventLabel: label };
    }
    createEventLabel(label, params) {
        const data = {};
        for (const [param, key] of Object.entries(params)) {
            data[param] = this.cmsDataStore.getData(key);
        }
        return parseTextParams(label, data);
    }
}
export default GaDataStore;
//# sourceMappingURL=GaDataStore.js.map